import mrApi from './mrApi';

export default {
  getPartial,
  getPartials,
};

export function getPartial(params) {
  return mrApi.get('/api/cmsSvc/getPartial', { params });
}

export function getPartials(params) {
  return mrApi.get('/api/cmsSvc/getPartials', { params });
}

export function getPromoDrawerPartials(params) {
  return mrApi.get('/api/cmsSvc/getPromoDrawerPartials', { params });
}
